<template>
  <div class="mctb_slide_01_ mctb-carousel-mctbslide">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'mctb-slide',
  data() {
    return {};
  },
};
</script>
